import React, { useState, useEffect } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  CircularProgress,
  Grid,
  Typography,
  Divider,
  FormControlLabel,
  FormControl,
  RadioGroup,
  FormHelperText,
  Radio,
  Button,
  Stack,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
} from '@mui/material';

import axios from 'axios';
import { useForm, useFieldArray, Controller, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { setFileData } from 'actions/counter';
import useStyles from './styles';
import RankingPosition from '../../components/FormFields/SelectRankingPosition';

const schema = yup.object().shape({
  firstName: yup
    .string()
    .matches(/^([^0-9]*)$/, 'First name should not contain numbers')
    .required('First name is a required field'),
});

function _sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function _submitFormRhf(data) {
  await _sleep(1000);
  alert(JSON.stringify(data, null, 2));
  // actions.setSubmitting(false);

  // insert TO DB
  // const isSuccess = await addEmployee(data);
  // if (!isSuccess) {
  //   alert(errMsg);
  // } else {
  //   setActiveStep(activeStep + 1);
  // }
}

const onSubmit = (data) => {
  // if (isLastStep) {
  //   setIsSubmittingFinal(true);
  _submitFormRhf(data);
  // } else {
  console.log('--------EmploymentPage---onSubmit-------');
  // setActiveStep(activeStep + 1);
  // actions.setTouched({});
  // actions.setSubmitting(false);
  // }
  // console.log('data', data);
};

export default function EmploymentPage() {
  const classes = useStyles();
  // const [errMsg, setErrMsg] = useState('');
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      title: '---title---',
      positionType: '',
      firstName: '---firstName11---',
      lastName: '---lastName1---',
      // duputy: 'รวห.',
      // rankingPositions: [{ code: 'AF', label: 'Afghanistan', phone: '93' }],
      placeOfBirth: '---',
    },
    resolver: yupResolver(schema),
  });

  const rhf = {
    useForm,
    useWatch,
    useFieldArray,
    Controller,
    control,
    setValue,
    getValues,
    errors,
  };

  // console.log('---isSubmitting----' + isSubmitting);

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        {currentUser.username}
        <Grid item xs={3} sm={3}>
          <Controller
            render={({ field, fieldState: { error } }) => (
              <TextField
                variant="filled"
                label="ชื่อ"
                fullWidthn
                error={!!error}
                helperText={error ? error.message : null}
                {...field}
              />
            )}
            name="firstName"
            control={control}
          />
        </Grid>
        <RankingPosition rhf={rhf} control={control}></RankingPosition>
        {/* <Grid item xs={3} sm={3}>
          
        </Grid> */}

        <div className={classes.buttons}>
          <div className={classes.wrapper}>
            <Button
              // disabled={isSubmittingFinal}
              type="submit"
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Submit
            </Button>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
}
